import script from "./Exports.vue?vue&type=script&lang=ts&setup=true"
export * from "./Exports.vue?vue&type=script&lang=ts&setup=true"

import "./Exports.vue?vue&type=style&index=0&id=cd908b8a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd908b8a"]])

export default __exports__